import React, { useEffect, useState } from "react";
import ProfileUnitView from "presentational/portfolio/ProfileUnitView";
import FollowListModal from "container/portfolio/FollowListModal";
import ProfileOptionModalView from "presentational/portfolio/ProfileOptionModalView";
import SettingsModalView from "presentational/portfolio/SettingsModalView";
import FullScreenLoadingView from "presentational/common/FullScreenLoadingView";
import Restful from "lib/restful";
import TXT from "presentational/common/multinational/TXT";
import CopyLinkTextView from "presentational/common/CopyLinkTextView";
import clipboardCopy from "lib/clipboardCopy";
import config from "lib/fr-config";
import { withStore } from "store/storeHandler";
import { useHistory } from "react-router-dom";
import { getEssentialUrl } from "lib/urlQueryParser";
import { withToken } from "lib/forceTokenRenewComponent";

const SHORTCUT_ROOT_URL = config.shortcutRootURL;

function MyProflie(props) {
  const {
    username,
    tokenAuthType,
    myProfile,
    userList,
    isLoading,
    isEnd,
    MyAccountActions,
    UserProfileActions,
    FollowUserListActions,
    AppErrorActions,
    NoticeModalActions
  } = props;
  const { getIdTokenWT } = props;
  const [optionModalOpen, setOptionModalOpen] = useState(false);
  const [settingsModalOpen, setSettingsModalOpen] = useState(false);
  const [followModalOpen, setFollowModalOpen] = useState(false);
  const [followModalType, setFollowModalType] = useState(null);
  const [needLoadingView, setNeedLoadingView] = useState(false);
  // const [userHash, setUserHash] = useState(null);

  const history = useHistory();

  useEffect(() => {
    requestMyProfile();
    requestMembershipData();
  }, []);

  const goToAnotherPage = url => {
    history.push(url);
  };

  /** hash 타입 url 임시 사용중지 */
  // const getHashShortcutUrl = async idToken => {
  //   /**
  //    * https://maunent.com/xShOs 같은 타입의 링크를 생성하는 함수
  //    */
  //   const resObj = { isSuccess: true, url: null };

  //   let myUserHash = userHash;
  //   if (!myUserHash) {
  //     const { code, res, errInfo } = await Restful.getMyUserHashAPI({
  //       idToken
  //     });
  //     if (code === "error") {
  //       const { apiName, data, httpCode, message } = errInfo;
  //       const errObj = Error("user-hash request error");
  //       errObj.errorValue = { apiName, data, httpCode, message };
  //       AppErrorActions.setSafeAppError(errObj);
  //       resObj.isSuccess = false;
  //       return resObj;
  //     } else {
  //       myUserHash = res.userHash;
  //       setUserHash(myUserHash);
  //     }
  //   }

  //   resObj.url = `${SHORTCUT_ROOT_URL}${getEssentialUrl({ type: "shortcutPortfolioHashType" })(myUserHash)}`;
  //   return resObj;
  // };

  const getUsernameShortcutUrl = () => {
    const url = `${SHORTCUT_ROOT_URL}${getEssentialUrl({
      type: "shortcutPortfolioUsernameType"
    })(username)}`;
    return { isSuccess: true, url };
  };

  const requestMyProfile = async () => {
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await UserProfileActions.initMyProfile(idToken);
    } catch (error) {
      AppErrorActions.setFatalAppError(error);
    }
  };

  const requestMembershipData = async () => {
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await MyAccountActions.updateMembershipData(idToken);
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  const submitItemOpenPresetData = async isItemListPublic => {
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await UserProfileActions.applyItemOpenPreset({
        isItemListPublic,
        idToken
      });
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  const hasItemOpenPresetChanged = input => {
    const { isItemListPublic } = myProfile.preset;
    return isItemListPublic !== input;
  };

  const handleMoreBtnClick = () => {
    setOptionModalOpen(true);
  };

  const handleFollowUserListBtnClick = async followModalType => {
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await FollowUserListActions.changeFollowList({
        type: followModalType,
        idToken
      });
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
      return null;
    }
    setFollowModalOpen(true);
    setFollowModalType(followModalType);
  };

  const handleRequestMoreFollowListBtnClick = async () => {
    if (isLoading) return null;

    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await FollowUserListActions.getList(idToken);
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  const handleLinkCopyClick = async () => {
    handleClose();

    setNeedLoadingView(true);
    /** hash 타입 코드 시작 */
    // const { idToken, hasTokenExpired } = await getIdTokenWT();
    // if (hasTokenExpired) return null;

    // const { isSuccess, url } = await getHashShortcutUrl(idToken);
    /** hash 타입 코드 끝 */

    /** username 타입 코드 시작 */
    const { isSuccess, url } = getUsernameShortcutUrl();
    /** username 타입 코드 끝 */
    setNeedLoadingView(false);
    if (!isSuccess) return null;

    clipboardCopy(url);
    NoticeModalActions.openModal({
      content: <CopyLinkTextView />
    });
  };

  const handleMembershipBtnClick = () => {
    goToAnotherPage(getEssentialUrl({ type: "membership" })());
  };

  const handleProfileImgChangeClick = () => {
    goToAnotherPage(getEssentialUrl({ type: "editProfileImage" })());
  };

  const handleChangeUsernameBtnClick = () => {
    goToAnotherPage(getEssentialUrl({ type: "changeUsername" })());
  };

  const handleChangePwBtnClick = () => {
    goToAnotherPage(getEssentialUrl({ type: "changePassword" })());
  };

  const handleLogOut = () => {
    MyAccountActions.requestNormalLogOut();
  };

  const handleLogOutForAllDevice = () => {
    MyAccountActions.requestAllDeviceLogOut();
  };

  const handleSettingsBtnClick = () => {
    handleClose();
    setSettingsModalOpen(true);
  };

  const handleUploadImgBtnClick = () => {
    goToAnotherPage(getEssentialUrl({ type: "uploadOutfit" })());
  };

  const handleSubmitAccountDeletion = async () => {
    await setNeedLoadingView(true);

    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) {
      await setNeedLoadingView(false);
      return null;
    }

    const { code, errInfo } = await Restful.deleteMyAccountAPI({ idToken });

    await setNeedLoadingView(false);

    if (code === "error") {
      handleLogOutForAllDevice();
      const errObj = Error("api error");
      errObj.errorValue = { ...errInfo };
      AppErrorActions.setFatalAppError(errObj);
      return null;
    } else if (code === "NowPaidUser") {
      NoticeModalActions.openModal({
        content: <TXT name="msg_paidUserDoesntQuit" />
      });
      return null;
    }

    NoticeModalActions.openModal({
      content: <TXT name="msg_accountDeletionCompleted" />,
      callback: null
    });
    handleLogOutForAllDevice();
  };

  const handleItemOpenPresetSubmit = async value => {
    if (!hasItemOpenPresetChanged(value)) {
      return null;
    }

    setNeedLoadingView(true);

    await submitItemOpenPresetData(value);

    setNeedLoadingView(false);
  };

  const handleClose = e => {
    setFollowModalOpen(false);
    setSettingsModalOpen(false);
    setOptionModalOpen(false);
    e && e.stopPropagation();
  };

  const render = () => {
    const { location, followingNum, gender, image, preset } = myProfile;

    return (
      <div>
        {needLoadingView && <FullScreenLoadingView />}
        <ProfileUnitView
          profileType="mine"
          ownerName={username}
          location={location}
          followingNum={followingNum}
          gender={gender}
          image={image}
          onFollowUserListBtnClick={handleFollowUserListBtnClick}
          firstBtnText={<TXT name="btnCommonContained_uploadOutfit" />}
          firstBtnStyle="bold"
          onFirstBtnClick={handleUploadImgBtnClick}
          onMoreBtnClick={handleMoreBtnClick}
        />
        <FollowListModal
          open={followModalOpen}
          modalType={followModalType}
          isLoading={isLoading}
          isEnd={isEnd}
          userList={userList}
          followingNum={followingNum}
          onRequestBtnClick={handleRequestMoreFollowListBtnClick}
          onClose={handleClose}
        />
        <ProfileOptionModalView
          open={optionModalOpen}
          onClose={handleClose}
          tokenAuthType={tokenAuthType}
          onMembershipBtnClick={handleMembershipBtnClick}
          onLinkCopyClick={handleLinkCopyClick}
          onLogOutClick={handleLogOut}
          onLogOutForAllDeviceClick={handleLogOutForAllDevice}
          onProfileImgChangeClick={handleProfileImgChangeClick}
          onChangeUsernameBtnClick={handleChangeUsernameBtnClick}
          onChangePwBtnClick={handleChangePwBtnClick}
          onSettingsBtnClick={handleSettingsBtnClick}
        />
        <SettingsModalView
          open={settingsModalOpen}
          onClose={handleClose}
          tokenAuthType={tokenAuthType}
          preset={preset}
          onProfileImgChangeClick={handleProfileImgChangeClick}
          onChangeUsernameBtnClick={handleChangeUsernameBtnClick}
          onChangePwBtnClick={handleChangePwBtnClick}
          onSubmitAccountDeletion={handleSubmitAccountDeletion}
          onItemOpenPresetSubmit={handleItemOpenPresetSubmit}
        />
      </div>
    );
  };

  return render();
}

export default withToken(
  withStore({
    stateMap: {
      myAccount: ["username"],
      cognitoAuth: ["tokenAuthType"],
      userProfile: ["myProfile"],
      followUserList: ["userList", "isLoading", "isEnd"]
    },
    dispatchMap: [
      "myAccount",
      "userProfile",
      "followUserList",
      "appError",
      "noticeModal"
    ]
  })(MyProflie)
);
